// extracted by mini-css-extract-plugin
export var container = "_lu-0";
export var dotAnimation = "_lu-2";
export var dotsLoading = "_lu-1";